import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function FooterSection() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="font-display text-3xl md:text-4xl font-black leading-none">
              PANDABUY
              <br />
              .SURF
            </p>
            <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
              The most updated PandabuySpreadsheet directory for 2026. Discover curated fashion, shoes, streetwear, and lifestyle finds — organized and updated daily.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-reddit-line", "ri-discord-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-wider text-white/40 mb-5">Categories</p>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.link}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/60 hover:text-white transition-colors py-1 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-wider text-white/40 mb-5">Quick Links</p>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors py-1">
                Home
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/60 hover:text-white transition-colors py-1"
              >
                pandabuy sheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/60 hover:text-white transition-colors py-1"
              >
                buy it now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} pandabuy.surf. We do not sell products directly.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-white/40 hover:text-white/70 transition-colors">Home</Link>
            <span className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Privacy</span>
            <span className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
}